import { useEffect, useState } from "react";
import { IUser } from "../../components/shared/UserList/UserList.types";
import { useGetApi } from "../../hooks";
import { getYachtId } from "../../utils";

interface Props {
  unit: string | undefined;
  defaultUsers: IUser[];
}
/**
 * Custom hook to fetch and manage users based on the provided unit.
 *
 * @param props - An object containing the following properties:
 *   - unit: A string representing the unit type (e.g., "med").
 *   - defaultUsers: An array of default users to use when the unit is not "med".
 * @returns An array of users fetched or the default users.
 */
export const useGetUsers = ({ unit, defaultUsers }: Props) => {
  const [users, setUsers] = useState<IUser[]>([]);
  const { refetch } = useGetApi({
    request: "get-med-users",
    body: {
      params: {
        yachtid: getYachtId(),
      },
    },
    fetchOnInit: false,
  });

  useEffect(() => {
    (async () => {
      if (unit?.includes("med")) {
        const data = await refetch();
        setUsers(data?.list ?? []);
      } else {
        setUsers(defaultUsers);
      }
    })();
  }, [unit, defaultUsers]);

  return users;
};
export default useGetUsers;
